import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

export type CreatedAtSortOrder = 'asc' | 'desc';

export interface CreatedAtSortHeaderProps {
  label: string;
  sortOrder: CreatedAtSortOrder;
  onToggle: () => void;
}

const HEADER_BUTTON_STYLE: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  margin: 0,
  padding: 0,
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  color: 'inherit',
  font: 'inherit',
  lineHeight: 1.2,
  whiteSpace: 'nowrap',
};

const CARET_STYLE: CSSProperties = {
  fontSize: 11,
  color: 'var(--evimo-text-muted, #6b7280)',
  lineHeight: 1,
};

export function CreatedAtSortHeader({
  label,
  sortOrder,
  onToggle,
}: CreatedAtSortHeaderProps) {
  const { t } = useTranslation('errorManagement');
  const SortIcon = sortOrder === 'desc' ? CaretDownOutlined : CaretUpOutlined;

  return (
    <button
      type="button"
      aria-label={
        sortOrder === 'desc' ? t('sortOldestFirst') : t('sortNewestFirst')
      }
      style={HEADER_BUTTON_STYLE}
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
    >
      <span>{label}</span>
      <SortIcon style={CARET_STYLE} aria-hidden />
    </button>
  );
}
